/**
 * 我的地點 API Service
 * 注意：axios 攔截器自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axiosInstance from '../api/axios';

const BASE = '/api/ee_my_locations';

export interface MyLocation {
  id:         number;
  user_id:    number;
  name:       string;
  lat:        number;
  lng:        number;
  note?:      string;
  created_at: string;
  updated_at?: string;
}

export interface MyLocationCreate {
  name: string;
  lat:  number;
  lng:  number;
  note?: string;
}

export interface MyLocationUpdate {
  name?: string;
  lat?:  number;
  lng?:  number;
  note?: string;
}

export const getMyLocations = async (): Promise<MyLocation[]> => {
  const res = await axiosInstance.get<MyLocation[]>(`${BASE}/`);
  return res.data;
};

export const createMyLocation = async (payload: MyLocationCreate): Promise<MyLocation> => {
  const res = await axiosInstance.post<MyLocation>(`${BASE}/`, payload);
  return res.data;
};

export const updateMyLocation = async (id: number, payload: MyLocationUpdate): Promise<MyLocation> => {
  const res = await axiosInstance.put<MyLocation>(`${BASE}/${id}`, payload);
  return res.data;
};

export const deleteMyLocation = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${id}`);
};
